export default __webpack_public_path__ + "static/media/trees.337750d6.svg";